<template>
    <div>
        <RouterView  v-show="!isLoading" />
        <div v-show="isLoading">
            <div class="fullview">
                <div class="loading-spacer"></div>
                <vue-loading
                    type="spin"
                    color="#333"
                    :size="{ width: '50px', height: '50px' }"
                ></vue-loading>
            </div>
        </div>
        <div v-show="isOpacityLoading">
            <div class="halfview">
                <div class="loading-spacer"></div>
                <vue-loading
                    type="spin"
                    color="#333"
                    :size="{ width: '50px', height: '50px' }"
                ></vue-loading>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { VueLoading } from "vue-loading-template";

export default {
    components: {
        VueLoading
    },
    computed: {
        ...mapState("loading", ["isLoading", "isOpacityLoading"])
    },
    data() {
        return {};
    },
    created() {}
};
</script>

<style>
.fullview {
    width: 100%;
    height: 100%;
    background: #fefefe;
    position: fixed;
    top: 0;
    left: 0;
}
.halfview {
    width: 100%;
    height: 100%;
    background: #fefefeaa;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}
.loading-spacer {
    height: 30%;
}
</style>
